import axios from 'axios'

// Capability requests must not use login redirects or the current user's JWT.
const publicApi = axios.create({
  baseURL: (process.env.VUE_APP_BASE_URL || '').replace(/\/?$/, '/'),
  timeout: 20000,
  withCredentials: false,
  headers: { Accept: 'application/json' }
})

export const isFeedbackPath = path => /^\/(?:fa|en)\/feedback(?:\/|$)/i.test(path)
export const validFeedbackUuid = uuid => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(uuid || '')
export const feedbackStage = status => status === 'todo' ? 'ors'
  : ['ors_filled', 'ors_skipped'].includes(status) ? 'srs'
    : status === 'completed' ? 'completed' : null
export const feedbackPath = (uuid, language = 'fa') => `/${language === 'en' ? 'en' : 'fa'}/feedback/${encodeURIComponent(uuid)}`
export const numericScore = value => value == null || value === '' || !Number.isFinite(Number(value)) ? null : Number(value)

export async function loadFeedback(uuid) {
  const response = await publicApi.get(`feedback/${encodeURIComponent(uuid)}`, { headers: { Authorization: undefined } })
  return response.data.data.therapy_result.status
}

export async function submitFeedback(uuid, payload) {
  const response = await publicApi.post(`feedback/${encodeURIComponent(uuid)}/assessment`, payload, { headers: { Authorization: undefined } })
  return response.data.data.therapy_result.status
}

export async function loadQuestionnaires() {
  const response = await axios.create({ timeout: 15000 }).get(`${process.env.BASE_URL}therapy-feedback/fa.json`)
  return response.data
}

export function questionnaireReady(questionnaire) {
  return !!(questionnaire && questionnaire.title && Array.isArray(questionnaire.questions)
    && questionnaire.questions.length === 4
    && questionnaire.questions.every(question => question.text && question.low && question.high))
}

export const completeAnswers = answers => answers.length === 4
  && answers.every(value => typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 10)
